// @flow
import { MMB_KEYS } from "../../mmb/consts/booking"

// MMB_KEYS are used for simplified handling of switch-case in Booking/Booking.js
export const BOOKING_LINKS: { [string]: string } = {
  [MMB_KEYS.INSURANCE]: "insurance",
  [MMB_KEYS.SEATING]: "seating",
  [MMB_KEYS.MEALS]: "meals-on-board",
  [MMB_KEYS.PETS]: "travelling-with-pets",
  [MMB_KEYS.SPECIAL_ASSISTANCE]: "special-assistance",
  [MMB_KEYS.SPORTS_EQUIPMENT]: "sports-equipment",
  [MMB_KEYS.MUSICAL_EQUIPMENT]: "musical-equipment",
  [MMB_KEYS.ACCOMMODATION]: "hotels",
  [MMB_KEYS.CAR_RENTAL]: "car-rental",
  [MMB_KEYS.BAGGAGE]: "bags",
  CHANGE_FLIGHTS: "change-trip",
  REFUND_APPLICATION: "refund-application",
  REFUND_CALCULATOR: "booking-cancellation",
  PASSENGERS: "passengers",
  ADDITIONAL_CONTACTS: "additional-contacts",
  EDIT_PASSENGERS: "passengers-edit",
  CANCEL_BOOKING: "cancel-booking",
  PENDING_SERVICES: "pending-services",
  TRAVEL_DOCUMENT: "completion",
  PAYMENT: "payment",
  AIRPORT_HELP: "airport-help",
  INVOICES: "invoices",
}
